 import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

import { MatDialog } from '@angular/material';

import { BaseManagement } from 'src/app/core/services/base-management';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { RequirementReviewService } from 'src/app/core/services/requirement-review.service';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { TranslateService } from '@ngx-translate/core';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { TransactionAdminRevisionStatusInternalService } from 'src/app/pages/transaction-admin/services/transaction-admin-revision-status-internal.service';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

@Component({
  selector: 'requirement-review',
  templateUrl: './requirement-review.component.html',
  styleUrls: ['./requirement-review.component.scss']
})
export class RequirementReviewComponent extends BaseManagement implements OnInit {
	public Editor = DecoupledEditor;
	form : FormGroup;
	comments: any[] = [];

	commentSelected: string = '';
	editorInstant: any;
	
	constructor(    
		public dialog: MatDialog,
		private mainService: RequirementReviewService,
		private transactionService: TransactionService,
		private formBuilder: FormBuilder,
		public translate: TranslateService,
		public transactionRequirementService: TransactionRequirementService,
		public transactionAdminRevisionStatusInternalService: TransactionAdminRevisionStatusInternalService

	) { 
		super();

		this.form = this.formBuilder.group({
		  "Comment":   ['', Validators.compose([Validators.required, Validators.minLength(10)])],
		 });      
	}	

	ngOnInit() {

		this.Editor.create( document.querySelector( '#editor'), {
		  toolbar: [
		    'heading', 
		    '|', 
		    'bold', 
		    'italic', 
		    'bulletedList', 
		    'numberedList', 
		    'blockQuote', 
			'|', 
		    'fontSize',
			'fontColor', 
		    'alignment' 
		  ],
			fontSize: {
				options: [
					'9px',
					'11px',
					'13px',
					'16px',
					'19px',
					'24px',
					'36px',
				],
				supportAllValues: false  // asegura que solo se puedan usar esos valores
			}
		})
      	.then( (editor: any) => {
          const toolbarContainer = document.querySelector( '#toolbar-container' );
          toolbarContainer.appendChild( editor.ui.view.toolbar.element );
		 editor.setData(this.commentSelected);
		  this.editorInstant = editor;
          editor.model.document.on('change:data', () => {
			let commentFormated = editor.getData().replace(/<[^>]*>/g, '');
			this.form.controls.Comment.patchValue(this.decodeHtml(commentFormated));
          });
		})
		.catch( (error: any) => {
			console.error( error );
		});

		this.mainService.getComments()
		.then( (data: any) => {
			this.comments = data;
			console.log(this.comments);
			
		})
	}

	removeTags(text: string){
		let textConverted = text.replace(/<[^>]*>/g, '');
		return textConverted;
	}

	decodeHtml(html: string): string {
		var txt = document.createElement("textarea");
		txt.innerHTML = html;
		return txt.value;
	}

	changeComment(event: any){
		console.log(event);
		this.commentSelected = this.decodeHtml(event.value);
		this.form.controls.Comment.patchValue(this.commentSelected);
		this.editorInstant.setData(this.commentSelected);
	}

	tryMarkForRevision(){
		this.translate.get(['requirementReview.questionMark', 
							'message.yes', 'message.no'])
		.subscribe(translations => {
	    let dialogRef = this.dialog.open(DialogYesNoComponent, {
	      width: '250px',
	      data: {
	        msg: translations['requirementReview.questionMark'],
	        yesText: translations['message.yes'],
	        noText: translations['message.no'],
	      }
	    });

	    dialogRef.afterClosed().subscribe(result => {      
	      if(result==1){
	        this.markForRevision();
	      }
	    });     
	    });
	}

	markForRevision(){
		this.translate.get(['requirementReview.markSuccess', 
							'message.yes', 'message.no'])
		.subscribe(translations => {
	    if(this.isSaving()) return;    

	    this.startSaving("mark-for-revision")

	    this.serverError = ""; 
		
		console.log(this.transactionRequirementService.UserProcessRequirementId);

	    this.mainService
	    .markForRevision(
			this.transactionService.itemToEdit.Id,
	    	this.mainService.requirementId, 
	    	true, 
	    	this.form.value
	    )
	    .then((result: any)=>{
			
			let params: any = {};
			params.userProcessId = this.transactionService.itemToEdit.Id;
			params.requirementId = this.mainService.requirement.RequirementId;

			this.transactionAdminRevisionStatusInternalService.createRevisionStatusLog(params)
			.then((data: any) => {
				this.transactionService.getById(this.transactionService.itemToEdit.Id)
				.then((data:any)=>{
					this.transactionAdminRevisionStatusInternalService
					.getUnfinalizedRevisionStatus(this.transactionService.itemToEdit.Id)
					.then((data: any)=>{
	
						this.transactionAdminRevisionStatusInternalService.hasUnfinalizedRevisions = data.HasUnfinalizedRevisions;
						console.log(data);
	
					})
					.catch((err) => {
						console.log('error',err);
						this.serverError = "An error ocurred when getting unfinalized revision status log."
						
					});
				});				
				console.log(data);
			})
			.catch((err) => {
				console.log('error',err);
				this.serverError = "An error ocurred when adding the revision status log."
				
			});


	        this.stopSaving();            
	      
	        if(result.Success == true){
	          let dialogRef = this.dialog.open(DialogYesNoComponent, {
	            width: '250px',
	            data: {
	              msg: translations['requirementReview.markSuccess'],
	              yesText: "Ok"
	            }
	          });     

	          dialogRef.afterClosed().subscribe(result => {      
	            this.close();
				this.transactionRequirementService.getRequirements(this.transactionService.itemToEdit.Id);
	            //this.transactionService.transactionRefresher.next("refresh-all")
	          });              
	        }else{
	          this.serverError = result.Message;
	        }
	    });  
	    });		
	}

	close(){
		this.mainService.requirementReviewFormIsVisible = false;
	}	
}